<template>
    <div>
        <div class="inmate-box-b">
            <img v-if="Inmate.photo"
                 class="inmate-image-b"
                 :src="'data:image/jpg;base64,' + Inmate.photo" />
            <img v-else
                 src="../../public/MissingInmateImage.png"
                 class="inmate-image" />
        </div>
        <div class="inmate-name-b">
            {{ Inmate.inmateLast }}, {{ Inmate.inmateFirst }}
        </div>
        <br />
        <div class="inmate-info-b">
            <div class="info-chunk">
                <div class="main-attributes">
                    <div class="section-title">General Information</div>
                    <br />
                    <table class="inmate-data-table">
                        <tr>
                            <td>Date of Birth:</td>
                            <td>{{ Inmate.birthDate }}</td>
                        </tr>
                        <!-- <tr>
                          <td>Alias:</td>
                          <td>{{ Inmate.alias }}</td>
                        </tr> -->
                        <!--<tr>
                            <td>Inmate ID:</td>
                            <td>{{ Inmate.inmateId }}</td>
                        </tr>-->
                        <tr>
                            <td>Booking ID:</td>
                            <td>{{ Inmate.bookingId }}</td>
                        </tr>
                        <tr>
                            <td>Booking Date:</td>
                            <td>{{ Inmate.bookingDate }}</td>
                        </tr>

                        <tr>
                            <td>Scheduled Release Date:</td>
                            <td>{{ Inmate.scheduledReleaseDate }}</td>
                        </tr>
                        <tr>
                            <td>Arresting Agency:</td>
                            <td>{{ Inmate.arrestAgency }}</td>
                        </tr>
                        <tr>
                            <td>Release Date:</td>
                            <td>{{ Inmate.releaseDate }}</td>
                        </tr>
                        <tr>
                            <td>Housing:</td>
                            <td>{{ Inmate.assignedFacilityId }}</td>
                        </tr>
                        <!-- <tr>
                          <td>Class Location:</td>
                          <td>{{Inmate.classLocation}}</td>
                        </tr> -->
                        <!-- <tr>
                          <td>Security Level:</td>
                          <td>{{Inmate.securityLevel}}</td>
                        </tr>           -->

                        <tr>
                            <td>Status:</td>
                            <td>{{ Inmate.inmateStatus }}</td>
                        </tr>
                    </table>
                    <br />
                </div>

                <!-- <br /> -->

                <div class="physical-attributes">
                    <div class="section-title">Physical Attributes</div>
                    <br />
                    <table class="inmate-data-table">
                        <tr>
                            <td>Age:</td>
                            <td>{{ Inmate.age }}</td>
                        </tr>
                        <tr>
                            <td>Gender:</td>
                            <td>{{ Inmate.gender }}</td>
                        </tr>
                        <tr>
                            <td>Height:</td>
                            <td>
                                {{
                  Inmate.heightFeet[0] +
                  "' " +
                  Inmate.heightFeet.substring(1, 3) +
                  '"'
                                }}
                            </td>
                        </tr>
                        <tr>
                            <td>Weight:</td>
                            <td>{{ Inmate.weight }}</td>
                        </tr>
                        <tr>
                            <td>Race:</td>
                            <td>{{ Inmate.race }}</td>
                        </tr>
                        <tr>
                            <td>Hair Color:</td>
                            <td>{{ Inmate.hairColor }}</td>
                        </tr>
                        <tr>
                            <td>Eye Color:</td>
                            <td>{{ Inmate.eyeColor }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <br />
            <div class="section-title">Offenses</div>
            <br />
            <!-- This section will show when the screen is too small for the chart style -->
            <div class="info-chunk entire-offenses-split">
                <div class="inmate-offenses"
                     v-for="offense in Inmate.offenses"
                     :key="offense.guid">
                    <table class="inmate-data-table">
                        <tr>
                            <td>Offense:</td>
                            <td>{{ offense.offenseDescription }}</td>
                        </tr>
                        <tr>
                            <td>Code:</td>
                            <td>{{ offense.chargeCode }}</td>
                        </tr>
                        <!--<tr>
                            <td>Sentence:</td>
                            <td>{{ offense.sentence }}</td>
                        </tr>-->
                        <tr>
                            <td>Charge Type:</td>
                            <td>{{ offense.convictionType }}</td>
                        </tr>
                        <tr>
                            <td>Date of Booking</td>
                            <td>{{ offense.offenseBookingDate }}</td>
                        </tr>
                        <tr>
                            <td>Release Date:</td>
                            <td>{{ offense.offenseReleaseDate }}</td>
                        </tr>
                        <tr>
                            <td>Bond Amount:</td>
                            <td>{{ offense.bondAmount }}</td>
                        </tr>
                        <tr>
                            <td>Next Court Date:</td>
                            <td>{{ offense.courtDate }}</td>
                        </tr>
                        <tr>
                            <td>Court Name:</td>
                            <td>{{ offense.court }}</td>
                        </tr>
                        <tr>
                            <td>Case Number:</td>
                            <td>{{ offense.courtCaseNumber }}</td>
                        </tr>
                    </table>
                    <br />
                </div>
            </div>
            <!-- <<<<<<<<<<<<<<<<<<<<<<<<<< UNDER CONSTRUCTION >>>>>>>>>>>>>>>>>>>>>>>>>>>> -->
            <div class="entire-offenses-table"
                 v-if="Inmate.offenses && Inmate.offenses.length > 0">
                <table class="offense-table">
                    <tr class="offense-titles">
                        <td @click="sortOffenses('offenseDescription')">
                            Offense
                            <div v-if="sortedBy == 'offenseDescription'">v</div>
                            <div v-if="sortedBy == 'offenseDescription2'">^</div>
                        </td>
                        <td @click="sortOffenses('chargeCode')">
                            Charge
                            <div v-if="sortedBy == 'chargeCode'">v</div>
                            <div v-if="sortedBy == 'chargeCode2'">^</div>
                        </td>
                        <td @click="sortOffenses('convictionType')">
                            Conviction Type
                            <div v-if="sortedBy == 'convictionType'">v</div>
                            <div v-if="sortedBy == 'convictionType2'">^</div>
                        </td>
                        <td @click="sortOffenses('offenseBookingDate')">
                            Date of Booking
                            <div v-if="sortedBy == 'offenseBookingDate'">v</div>
                            <div v-if="sortedBy == 'offenseBookingDate2'">^</div>
                        </td>
                        <td @click="sortOffenses('offenseReleaseDate')">
                            Release Date
                            <div v-if="sortedBy == 'offenseReleaseDate'">v</div>
                            <div v-if="sortedBy == 'offenseReleaseDate2'">^</div>
                        </td>
                        <td @click="sortOffenses('bondAmount')">
                            Bond Amount
                            <div v-if="sortedBy == 'bondAmount'">v</div>
                            <div v-if="sortedBy == 'bondAmount2'">^</div>
                        </td>
                        <td @click="sortOffenses('courtDate')">
                            Next Court Date
                            <div v-if="sortedBy == 'courtDate'">v</div>
                            <div v-if="sortedBy == 'courtDate2'">^</div>
                        </td>
                        <td @click="sortOffenses('court')">
                            Court Name
                            <div v-if="sortedBy == 'court'">v</div>
                            <div v-if="sortedBy == 'court2'">^</div>
                        </td>
                        <td @click="sortOffenses('courtCaseNumber')">
                            Case Number
                            <div v-if="sortedBy == 'courtCaseNumber'">v</div>
                            <div v-if="sortedBy == 'courtCaseNumber2'">^</div>
                        </td>
                    </tr>
                    <tr class="offense-values"
                        v-for="offense in Inmate.offenses"
                        :key="offense.guid">
                        <td>{{ offense.offenseDescription }}</td>

                        <td>{{ offense.chargeCode }}</td>

                        <td>{{ offense.convictionType }}</td>

                        <td>{{ offense.offenseBookingDate }}</td>

                        <td>{{ offense.offenseReleaseDate }}</td>

                        <td>{{ offense.bondAmount }}</td>

                        <td>{{ offense.courtDate }}</td>

                        <td>{{ offense.court }}</td>

                        <td>{{ offense.courtCaseNumber }}</td>
                        <!-- END OF TABLE -->
                    </tr>
                </table>
            </div>
            <div v-else>-- <b>NONE FOUND</b> --</div>
            <!-- <<<<<<<<<<<<<<<<<<<<<<<<<< UNDER CONSTRUCTION >>>>>>>>>>>>>>>>>>>>>>>>>>>> -->
        </div>
    </div>
</template>

<script>
    import { eventBus } from "../main.js";

    export default {
        props: ["Inmate"],
        data() {
            return {
                sortedBy: "",
            };
        },
        methods: {
            // Smart sorter that determines if the field is a date, then sorts in DESCENDING (a -> z) order. Click again to sort by ASCENDING (z -> a).
            sortOffenses(sortBy) {
                let isDate = false;
                if (sortBy.includes("Date") || sortBy.includes("date")) {
                    isDate = true;
                }
                if (this.sortedBy != sortBy) {
                    this.Inmate.offenses = this.Inmate.offenses.sort((a, b) => {
                        if (a[sortBy] === null || a[sortBy] === "") {
                            return 1;
                        } else if (b[sortBy] === null || b[sortBy] === "") {
                            return -1;
                        } else {
                            if (a[sortBy] > b[sortBy]) {
                                if (isDate) {
                                    return -1;
                                } else {
                                    return 1;
                                }
                            } else if (isDate) {
                                return 1;
                            } else {
                                return -1;
                            }
                        }
                    });
                    this.sortedBy = sortBy;
                } else {
                    this.Inmate.offenses = this.Inmate.offenses.sort((a, b) => {
                        if (a[sortBy] === null || a[sortBy] === "") {
                            return 1;
                        } else if (b[sortBy] === null || b[sortBy] === "") {
                            return -1;
                        } else {
                            if (a[sortBy] < b[sortBy]) {
                                if (isDate) {
                                    return -1;
                                } else {
                                    return 1;
                                }
                            } else if (isDate) {
                                return 1;
                            } else {
                                return -1;
                            }
                        }
                    });
                    this.sortedBy = sortBy + "2";
                }
            },
            // General Utility Methods

            // Call this to open the modal window after setting the values in the store
            modalOpen() {
                this.$nextTick(() => {
                    eventBus.$emit("openModalWindow");
                });
            },

            // Run this before OR after each use of the modal window (use the same choice for every use of the modal window)
            resetModalWindow() {
                eventBus.$emit("clearModalData");
            },
        },
        created() {
            // document.getElementById("inmate-image").src = "../../public/" + this.Inmate.image
        },
    };
</script>

<style>
    .offense-table {
        width: 100%;
        border-spacing: 0;
        border: 2px solid rgb(18, 27, 102);
        border-collapse: separate;
        border-radius: 5px;
        color: rgb(18, 27, 102);
    }

        .offense-table * {
            padding: 3px 0;
        }

    .offense-titles td {
        font-weight: bold;
        /* border-top: 2px solid black; */
        border: 1px solid rgb(18, 27, 102);
        /* border-top: 2px solid black; */
        /* border-right: 1px solid black; */
        background-color: rgb(225, 225, 225);
        /* border-radius: 2px 2px 0 0; */
        /* position: sticky;
      top: 0; */
    }

    .offense-titles {
        position: sticky;
        top: -1px;
        height: 56px;
        /* border: 2px solid black; */
    }

        .offense-titles td:hover {
            background-color: white;
            cursor: pointer;
        }

    .offense-values td {
        border-bottom: 1px solid rgba(18, 27, 102, 0.2);
        border-right: 1px solid rgba(18, 27, 102, 0.2);
    }

    .offense-values:hover {
        background-color: rgb(200, 200, 200) !important;
        cursor: default;
    }

    .offense-values:nth-child(odd) {
        background-color: rgb(235, 235, 235);
    }

    /* Above is experimental CSS for the offenses table */

    .section-title {
        font-weight: bold;
        text-decoration: underline;
        font-size: 22px;
        color: rgb(18, 27, 102);
    }

    .inmate-data-table {
        margin: auto;
    }

    .info-chunk tr td:first-child {
        font-weight: bold;
        text-align: right;
        width: 300px;
    }

    .info-chunk tr td:last-child {
        text-align: left;
        width: 300px;
    }

    .inmate-image-b {
        max-width: 40%;
        min-width: 200px;
        max-height: 10%;
        /* min-height: 300px; */
        margin: 40px auto 20px;
        border: 1px solid black;
        /* overflow: hidden; */
    }

    .inmate-info-b {
        /* width: 350px; */
        margin-bottom: 40px;
        text-align: center;
        /* display: flex; */
        /* padding-left: 20px; */
        /* padding-left: 50px; */
        /* padding-left: 50px; */
        /* margin-top: 20px; */
    }

    .info-chunk {
        display: flex;
        margin: auto;
        justify-content: center;
        /* width: 50%; */
        flex-wrap: wrap;
    }

        .info-chunk > * {
            width: 400px;
        }

    /* .offenses-chunk {
      display: flex;
      margin: auto;
      justify-content: space-around;
      flex-wrap: wrap;
    } */

    .inmate-offenses {
        width: 400px;
    }

    .entire-offenses-split {
        display: none;
    }

    /* .inmate-offenses {
      display: flex;
      margin: auto;
      justify-content: space-around;
    } */

    /*
    .main-attributes {
      width: 50%;
    }
    .physical-attributes {
      width: 50%;
    } */

    .info-title-b {
        font-weight: bold;
        font-size: 20px;
        display: block;
        text-decoration: underline;
        text-align: center;
        margin-top: 7px;
        margin-bottom: 2px;
    }

    .inmate-name-b {
        font-size: 28px;
        text-align: center;
        color: rgb(18, 27, 102);
        margin: 5px 0;
        text-decoration: underline;
        font-weight: bold;
    }

    @media screen and (max-width: 900px) {
        .entire-offenses-table {
            display: none;
        }

        .entire-offenses-split {
            display: flex;
        }
    }

    /* .inmate-name-b:hover {
      text-decoration: underline;
      cursor: pointer;
      color: rgb(68,87,152);
    } */
</style>